import { render } from "./BaseModal.vue?vue&type=template&id=53aa85d9&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=53aa85d9&lang=scss&scoped=true"

import exportComponent from "/home/dijuno-mobile/dijuno-mobile.pderasapps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53aa85d9"]])

export default __exports__